var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3324 6.68533V6.67509L18.107 5.34339C17.9533 4.40095 17.728 2.9873 15.3309 2.9873H12.647C10.2602 2.9873 10.0349 4.33949 9.87095 5.33314L9.65583 6.64436C8.70315 6.70582 7.75048 6.76728 6.7978 6.85948L4.70806 7.06435C4.27782 7.10533 3.9705 7.48435 4.01148 7.90435C4.05245 8.32435 4.42123 8.63166 4.85147 8.59069L6.94121 8.38581C12.309 7.85313 17.7177 8.05801 23.147 8.60093C23.1777 8.60093 23.1982 8.60093 23.2289 8.60093C23.6182 8.60093 23.9562 8.30386 23.9972 7.90435C24.0279 7.48435 23.7206 7.10533 23.2904 7.06435C21.6411 6.90045 19.9919 6.77753 18.3324 6.68533Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4731 9.64466H7.52491C7.17662 9.64466 6.82833 9.78807 6.59272 10.0442C6.35711 10.3003 6.22394 10.6486 6.24443 11.0071L6.87955 21.5173C6.99223 23.0743 7.13564 25.0207 10.7107 25.0207H17.2873C20.8624 25.0207 21.0058 23.0846 21.1185 21.5173L21.7536 11.0173C21.7741 10.6486 21.6409 10.3003 21.4053 10.0442C21.1595 9.78807 20.8214 9.64466 20.4731 9.64466ZM12.2883 19.8885C11.8683 19.8885 11.52 19.5402 11.52 19.1202C11.52 18.7002 11.8683 18.3519 12.2883 18.3519H15.6995C16.1195 18.3519 16.4678 18.7002 16.4678 19.1202C16.4678 19.5402 16.1195 19.8885 15.6995 19.8885H12.2883ZM11.4381 15.791C11.0181 15.791 10.6698 15.4427 10.6698 15.0227C10.6698 14.6027 11.0181 14.2544 11.4381 14.2544H16.56C16.98 14.2544 17.3283 14.6027 17.3283 15.0227C17.3283 15.4427 16.98 15.791 16.56 15.791H11.4381Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8c7b24768a69af79cef31dd9065fd566.svg";
export { ForwardRef as ReactComponent };